import React from "react";
import ReportsList from "src/pages/Reports/Config";
import ReportPanel from "src/pages/Reports/Panel";
import ReportView from "src/pages/Reports/View";
import RoutePrivate from "./private";

export default [
	<RoutePrivate path="/reports" key="reports" exact component={ReportsList} isPrivate/>,
	<RoutePrivate path="/reports/panel" key="reportsPanel" exact component={ReportPanel} isPrivate/>,
	<RoutePrivate path="/reports/panel/:grouperIndex" permissionPath="/reports/panel" key="reportsPanelGrouperID" exact component={ReportPanel} isPrivate/>,
	<RoutePrivate path="/reports/view/:reportId" permissionPath="/reports/panel" key="reportsView" exact component={ReportView} isPrivate/>
];
